import { computed, Injectable, signal } from '@angular/core';
import { Carriers } from 'app/shared/enum/general-enum';
import { EUCountries } from 'app/shared/models/countries-eu.model';

@Injectable()
export class ShipmentStateService {
    public isShipToZipRestricted = signal<boolean>(false);

    public shipFromCountryCode = signal<string>(null);
    public shipToCountryCode = signal<string>(null);
    public carrier = signal<Carriers>(null);

    private euCountryCodes = EUCountries.map(country => country.alpha2Code);

    public isInternational = computed(() => {
        const isFromEU = this.euCountryCodes.includes(this.shipFromCountryCode());
        const isToEU = this.euCountryCodes.includes(this.shipToCountryCode());
        const isFedex = +Carriers[this.carrier()] === Carriers.Fedex;

        if (isFromEU && isToEU && !isFedex) {
            return false;
        }

        return this.shipFromCountryCode() !== this.shipToCountryCode();
    });
}
